import { toast } from "react-toastify";

import { resolveAccess } from "../services/rbacService";

export function formatCash(amount) {
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/** KES + thousands separators; same pattern as month collections on the dashboard. */
export function formatKesCollections(value: unknown): string {
  if (value === undefined || value === null) {
    return "";
  }
  if (typeof value === "string") {
    const t = value.trim();
    if (t === "N/A" || t === "") {
      return t;
    }
    const withoutKes = t
      .replace(/^KES\s*/i, "")
      .replace(/,/g, "")
      .trim();
    const n = Number(withoutKes);
    if (!Number.isFinite(n)) {
      return t;
    }
    return `KES ${formatCash(n)}`;
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    return `KES ${formatCash(value)}`;
  }
  return String(value);
}

export const _updatePhoneNumber = (_searchValue) => {
  _searchValue = _searchValue.replace("+", "");

  if(_searchValue.startsWith("7"))
    return "254"+_searchValue;

  if(_searchValue.startsWith("1"))
    return "254"+_searchValue;

  if(_searchValue.startsWith("02"))
    return _searchValue.replace("0", "254");

  if (_searchValue.startsWith("0254")) {
    return _searchValue.replace("0", "");
  }
  if (
    _searchValue.startsWith("07") ||
    _searchValue.startsWith("02") ||
    _searchValue.startsWith("01")
  ) {
    return _searchValue.replace("0", "254");
  }

  return _searchValue;
};

export const apiErrorHandler = (_err, _message = null) => {
  toast.error(
    _message === null ? `Error updating details, please try again.` : _message,
  );
};

export function insertSpinner() {
  let spinnerContainer = document.createElement("div");
  spinnerContainer.classList.add("spinner-border");
  spinnerContainer.setAttribute("role", "status");
  let spinner = document.createElement("span");
  spinner.className = "sr-only";
  spinner.textContent = "Loading...";
  spinnerContainer.appendChild(spinner);

  return spinnerContainer;
}

export function fetchErrorUI(
  _err,
  _message = "An error Occured while fetching some data please reload page!",
) {
  console.log("sss: ", _err);
  toast.error(_message, { position: toast.POSITION.TOP_CENTER });
}

export function postErrorUI(
  _message = "An error Occured while posting your updates. Please try again!",
) {
  toast.error(_message, { position: toast.POSITION.TOP_CENTER });
}

export function capitalizeFirstLetter(str) {
  // converting first letter to uppercase
  const capitalized = str.charAt(0).toUpperCase() + str.slice(1);
  return capitalized;
}

// function getOwnerMatatus() {
//   const profile = JSON.parse(window.sessionStorage.getItem("profile"));
//   return profile.role.toLowerCase() == "owner" ? profile.matatuList : "";
// }

export const setStatusClass = (_status) => {
  switch (_status) {
    case true:
      return "badge-success";
    case false:
      return "badge-secondary";
    // operator statuses
    case "active":
      return "badge-success";
    case "inactive":
      return "badge-secondary";
    case "suspended":
      return "badge-danger";
    // parcel statuses
    case "registered":
    case "REGISTERED":
      return "badge-secondary";
    case "PAID":
      return "badge-success";
    case "IN_TRANSIT":
      return "badge-warning";
    case "DELIVERED":
      return "badge-info";
    case "RECEIVED":
      return "badge-teal";
    case "CANCELLED":
      return "badge-danger";
    default:
      return "badge-warning";
  }
};

export const setStatusColor = (status) => {
  switch (status) {
    case "online":
      return "badge-success-lighten";
    case "offline":
      return "badge-danger-lighten";
    default:
      return "badge-secondary-lighten";
  }
};

export const verifyMatatu = (_matatu, _action) => {
  let _errorMessage = "";

  if (_action === "save") {
    if (!_matatu.licensePlate) _errorMessage += "License Plate ,";
    if (!_matatu.numberOfSeats) _errorMessage += "Number Of Seats, ";
  }

  if (!_matatu.subscriptionType) _errorMessage += "Subscription Type, ";
  if (!_matatu.wallet) _errorMessage += "Wallet, ";
  if (!_matatu.routeNumber) _errorMessage += "Route Number, ";
  if (!Object.keys(_matatu.operators).length) _errorMessage += "Crew, ";
  if (!_matatu.saccoName) _errorMessage += "Sacco Name, ";

  if (_errorMessage) {
    toast.error("Missing required fields: " + _errorMessage);
    return false;
  }
  return true;
};

export const verifyCrewMember = (_crew, _action) => {
  let _errorMessage = "";

  if (_action === "save") {
    if (!_crew.firstName) _errorMessage += "First Name, ";
    if (!_crew.lastName) _errorMessage += "Last Name, ";
    if (!_crew.phoneNumber) _errorMessage += "Phone Number, ";
    if (!_crew.idNumber) _errorMessage += "ID Number. ";
  }

  if (!_crew.matatu) _errorMessage += "Matatu ";
  if (!_crew.role) _errorMessage += "Role ";
  // if (!_crew.status) _errorMessage += "Status ";

  if (_errorMessage) {
    toast.error("Missing required fields: " + _errorMessage);
    return false;
  }
  return true;
};

export const verifyParcelDetails = (_parcel, _action) => {
  let _errorMessage = "";
  if (_action === "save") {
    //check sender details validity
    if (!_parcel.sender.firstName) _errorMessage += "Sender First Name, ";
    if (!_parcel.sender.lastName) _errorMessage += "Sender Last Name, ";
    if (!_parcel.sender.phoneNumber) _errorMessage += "Sender Phone Number, ";

    //check receiver details validity
    if (!_parcel.recipient.firstName) _errorMessage += "Receiver First Name, ";
    if (!_parcel.recipient.lastName) _errorMessage += "Receiver Last Name, ";
    if (!_parcel.recipient.phoneNumber)
      _errorMessage += "Receiver Phone Number, ";
  }

  if (!_parcel.matatu) _errorMessage += "Matatu ";
  if (!_parcel.origin) _errorMessage += "Origin ";
  if (!_parcel.destination) _errorMessage += "Destination ";
  if (!_parcel.amountPaid) _errorMessage += "Amount ";
  if (!_parcel.matatuAmount && _parcel.matatuAmount !== 0) _errorMessage += "Matatu Amount ";

  if (_errorMessage) {
    toast.error("Missing required fields: " + _errorMessage);
    return false;
  }
  return true;
};

export const formatSaccoMember = (_user) => {
  return {
    email: _user.email,
    firstName: _user.firstName,
    id: _user.id,
    idNumber: _user.idNumber,
    isVerified: _user.verified ?? _user.isVerified,
    lastName: _user.lastName,
    matatuList: _user.matatuList,
    photo: _user.photo,
    role: _user?.role,
    sacco: _user.sacco,
  };
};
export function formatDate(value) {
  // formating for date filters
  let _day = value.getDate() < 10 ? "0" + value.getDate() : value.getDate();
  let _month =
    value.getMonth() + 1 < 10
      ? "0" + (value.getMonth() + 1)
      : value.getMonth() + 1;

  return parseInt(value.getFullYear().toString()) + "-" + _month + "-" + _day;
}

/** False for Invalid Date, empty, or strings like "NaN-NaN-NaN" from bad formatDate input. */
export function isValidSummaryDateKey(dateKey: string): boolean {
  if (dateKey == null || typeof dateKey !== "string") return false;
  const t = dateKey.trim();
  if (t === "") return false;
  if (/NaN/i.test(t)) return false;
  const d = new Date(t);
  return Number.isFinite(d.getTime());
}

export const formatPhoneNumber = (_phoneNumber) => {
  if (!_phoneNumber) return _phoneNumber;
  if (_phoneNumber[0] === "0") _phoneNumber = _phoneNumber.slice(1);
  if (_phoneNumber.slice(0, 3).includes("254")) {
    _phoneNumber = _phoneNumber.slice(3);
  }
  if (_phoneNumber.slice(0, 4).includes("+254")) {
    _phoneNumber = _phoneNumber.slice(4);
  }

  return _phoneNumber;
};

/** Local Kenyan display format: 07… / 01…, or 0 after stripping +254/254. */
export const formatDisplayPhoneNumber = (
  phoneNumber: string | number | null | undefined,
): string => {
  if (phoneNumber == null) return "";
  let phone = String(phoneNumber).trim();
  if (!phone) return "";

  if (phone.startsWith("+254")) {
    phone = "0" + phone.slice(4);
  } else if (phone.startsWith("254")) {
    phone = "0" + phone.slice(3);
  }

  if (phone.startsWith("01") || phone.startsWith("07")) {
    return phone;
  }

  if (!phone.startsWith("0")) {
    phone = "0" + phone;
  }

  return phone;
};

/** @deprecated Prefer resolveAccess / canAccessPath from rbacService. */
export const userAccessLevel = (user, location = "") =>
  resolveAccess(user, location);
